import * as fromDatatype from '../datatype-library/index';

export interface bl_hc_patient_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  date_of_birth: fromDatatype.TimestampTzDatatypeInterface;
  gender: fromDatatype.VarcharDatatypeInterface;
  height: fromDatatype.VarcharDatatypeInterface;
  weight: fromDatatype.VarcharDatatypeInterface;
  address_json: fromDatatype.JsonDatatypeInterface;
  phone: fromDatatype.VarcharDatatypeInterface;
  email: fromDatatype.VarcharDatatypeInterface;
  blood_group: fromDatatype.VarcharDatatypeInterface;
  insurance_provider: fromDatatype.VarcharDatatypeInterface;
  policy_number: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_hc_patient_hdr_RowClass implements bl_hc_patient_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  date_of_birth: fromDatatype.TimestampTzDatatypeInterface;
  gender: fromDatatype.VarcharDatatypeInterface;
  height: fromDatatype.VarcharDatatypeInterface;
  weight: fromDatatype.VarcharDatatypeInterface;
  address_json: fromDatatype.JsonDatatypeInterface;
  phone: fromDatatype.VarcharDatatypeInterface;
  email: fromDatatype.VarcharDatatypeInterface;
  blood_group: fromDatatype.VarcharDatatypeInterface;
  insurance_provider: fromDatatype.VarcharDatatypeInterface;
  policy_number: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}